import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <main className="min-h-screen grid place-items-center bg-paper text-center px-6" data-testid="not-found-page">
      <div>
        <p className="font-serif italic text-6xl">Lost? Good start.</p>
        <Link to="/" className="mt-6 inline-block underline underline-offset-4">Back home</Link>
      </div>
    </main>
  );
}
